"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currencies = exports.Currency = void 0;
class Currency {
    constructor(currency) {
        this.id = 1;
        this.name = 'Bitcoin';
        this.tag = 'BTC';
        this.fiat = false;
        this.fee = 0;
        this.feePct = 0;
        this.minWithdraw = 0;
        this.canDeposit = true;
        this.canWithdraw = true;
        if (!currency)
            return;
        this.id = currency.id;
        this.name = currency.name;
        this.tag = currency.tag;
        this.fiat = currency.fiat;
        this.fee = currency.fee;
        this.feePct = currency.feePct;
        this.minWithdraw = currency.minWithdraw;
        this.tokenOf = currency.tokenOf;
        this.canDeposit = currency.canDeposit;
        this.canWithdraw = currency.canWithdraw;
    }
}
exports.Currency = Currency;
class Currencies {
    constructor() {
        this.list = {};
    }
}
exports.Currencies = Currencies;
//# sourceMappingURL=currency.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exchange-common/models/currency.js
// module id = 191
// module chunks = 0